import styled from '@emotion/styled'

export const Name = styled.h1`
  margin: 1em 0 3em;
  text-align: center;
  font-size: 1.6em;
  font-weight: 600;
`

export const Counters = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: .3em;
  margin-bottom: 3em;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const Number = styled.span`
  font-size: 2.2em;
  font-weight: 500;
`

export const Label = styled.span`
  font-size: 1em;
`

export const Info = styled.span`
  text-align: center;
  display: block;
  margin-top: 1em;
  font-size: .9em;
`

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: .8em;
  margin-top: 3em;
  flex-wrap: wrap;
  justify-content: flex-end;

  & > div {
    flex: 1;
  }

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    flex-direction: column-reverse;

    & > a, & > button {
      width: 100%;
    }
  }
`